import React from 'react';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import Avatar from '@components/@core/Avatar';

const moment = extendMoment(originalMoment);

const EmployeeList = ({ users }) => {
    return (
        <div className="card">
            <p className="dsl-b16 bold">Learning Track Report</p>
            <div className="d-flex py-2 border-bottom">
                <div className="d-flex-3 dsl-m12">Teams</div>
                <div className="d-flex-1 dsl-m12 text-end">Started</div>
                <div className="d-flex-1 dsl-m12 text-end">Due date</div>
                <div className="d-flex-1 dsl-m12 text-end">Completed</div>
            </div>
            {users?.map((item, index) => {
                const { user, track, stats } = item;
                const { first_name, last_name, avatar } = user.profile;
                return (
                    <div className="d-flex py-3 cursor-pointer border-bottom" key={index}>
                        <div className="d-flex d-flex-3">
                            <Avatar name={`${first_name} ${last_name}`} url={avatar} />
                            <div className="d-flex-2 dsl-b14 ms-2 text-start text-400 align-self-center">{`${first_name} ${last_name}`}</div>
                        </div>
                        <div className="d-flex-1 dsl-b14 text-400 text-end">{moment(track?.created_at).format('MMM D, YY')}</div>
                        <div className="d-flex-1 dsl-b14 text-400 text-end">{moment(track?.due_date).format('MMM D, YY')}</div>
                        <div className="d-flex-1 dsl-b14 text-400 text-end">{stats?.courses_completed?.count}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default EmployeeList;
